export default __webpack_public_path__ + "static/media/baby1 10.17 1.d0358ae0.png";